(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2774],{

/***/ 96339:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ ethics; }
});

// EXTERNAL MODULE: ./components/Texts/TextsPage.tsx
var TextsPage = __webpack_require__(36473);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/Texts/EthicsPage.tsx



var EthicsPage = function EthicsPage(_ref) {
  var data = _ref.data;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(TextsPage/* default */.Z, {
    title: data === null || data === void 0 ? void 0 : data.title,
    text: data === null || data === void 0 ? void 0 : data.body
  });
};

/* harmony default export */ var Texts_EthicsPage = (EthicsPage);
// EXTERNAL MODULE: ./common/SeoMetaData.tsx
var SeoMetaData = __webpack_require__(31353);
;// CONCATENATED MODULE: ./src/pages/ethics.tsx






var Ethics = function Ethics(_ref) {
  var data = _ref.data,
      seo = _ref.seo;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SeoMetaData/* default */.ZP, {
      data: seo
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Texts_EthicsPage, {
      data: data
    })]
  });
};

var __N_SSG = true;
/* harmony default export */ var ethics = (Ethics);

/***/ }),

/***/ 78374:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ethics",
      function () {
        return __webpack_require__(96339);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9415,9774,2888,179], function() { return __webpack_exec__(78374); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);